import React, { createContext, useContext, useState } from 'react';

const emptyStageInfo = {
  stageTitle: null,
  stageSubtitle: null,
  stageNavigation: null,
};

const CurrentStageContext = createContext({
  ...emptyStageInfo,
  setStageInfo: () => {},
});

export const CurrentStageProvider = ({ children }) => {
  const [stageInfo, setStageInfo] = useState(emptyStageInfo);
  return (
    <CurrentStageContext.Provider value={{ ...stageInfo, setStageInfo }}>
      {children}
    </CurrentStageContext.Provider>
  );
};

export const useCurrentStage = () => useContext(CurrentStageContext);

export default CurrentStageContext;
